/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../Form";
import useForm from "../../hooks/useForm";
import Modal, { ModalHeader } from "../Modal";
import systemAlert from "../../utils/systemAlert";
import { sendEmail } from "../../apis/admin/email";

const defaultForm = {
  emailSubject: '',
  emailForm: '',
  "sendType": "all",
  "macros": ["name", "email", "companyName", "aboutCompany", "businessType", "consultingType", "employeeCount", "description",],

}

const Consulting = (props) => {
  const { open, setOpen } = props
  const [fields, setFields] = useState([]);
  const [mode] = useState('create')

  useEffect(() => {
    setFields([
      [
        {
          title: "제목",
          key: "emailSubject",
          type: "input",
          required: true,
        },
      ],

      [
        {
          title: "내용",
          key: "emailForm",
          type: "textarea",
          required: true,
        },
      ],
    ])
  }, [mode])

  useEffect(() => {
    setValidateFields(fields)

    const defaultFormData = {
      ...defaultForm
    }
    setForm(defaultFormData);
    setOriginForm(defaultFormData)
  }, [open]);

  const _submit = (form) => {
    systemAlert(`문의주신 전체에게 메일을 보내시겠습니까?`, {

      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            sendEmail({
              ...form,
              emailForm: window.btoa(encodeURIComponent(form.emailForm))
            })
              .then(() => {
                cancel();
              })
          }
        }
      ]
    })
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>AD 메일보내기</ModalHeader>
        <div className="ad-mail-description">
          <p>
            macros 기능은 name,emil,companyName 이 가능합니다. <br />(그외 aboutCompany, businessType, consultingType, employeeCount 가능)
          </p>
          <p>
            사용 방법은 $&#123;macro&#125; 로 사용 가능합니다.
          </p>
          <p>
            상담 신청 및 무료체험 모두에게 메일이 발송됩니다. <br />
          </p>
          <br />
        </div>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '전체 보내기' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default Consulting;
